export const sortOrders = (ordersToSort) => {
    return ordersToSort.sort((a, b) => {
        if (!a.orderTimestamp || !b.orderTimestamp) {
            return 1;
        }

        if (Number(a.orderTimestamp) > Number(b.orderTimestamp)) return 1;
        else return -1;
    });
}

export const sortCompleteOrders = (ordersToSort) => {
    return ordersToSort.sort((a, b) => {
        const aTime = a.statusHistory.find((item) => item.status === 'ACCEPTED');
        const bTime = b.statusHistory.find((item) => item.status === 'ACCEPTED');

        if (Number(aTime.eventCompletedTime) < Number(bTime.eventCompletedTime)) return 1;
        else return -1;
    });
}

export function isNotEmptyString(text) {
    return text !== undefined && text !== null && text.length > 0;
}

export function isAdminView() {
    const domain = window.location.hostname;
    return domain.startsWith("admin-");
}

export function getJWTPayload (token) {
    const parts = token.split('.');
    return JSON.parse(atob(parts[1]));
}

/**
 * This function is used to get the id token payload from the auth data.
 * This is used to handle old local storage data where the id token payload is not stored separately.
 */
export function getAuthTokenIdPayload(authData) {
    if (authData?.idTokenPayload) {
        return authData.idTokenPayload;
    }
    //to handle old local storage data where the id token payload is not stored separately
    return authData?.signInUserSession?.idToken?.payload
}